import { render, staticRenderFns } from "./HandleCptu.vue?vue&type=template&id=d01c4c44"
import script from "./HandleCptu.vue?vue&type=script&lang=js"
export * from "./HandleCptu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports